import { render, staticRenderFns } from "./filter-groups.vue?vue&type=template&id=5118367b"
import script from "./filter-groups.vue?vue&type=script&lang=js"
export * from "./filter-groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports